// @flow
import * as React from 'react';
import { makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { pipe } from 'ramda';
import { Modal } from '../../basic/Modal';
import { Button } from '../../basic/Button';
import splashBg from '../../../assets/images/splash-bg.svg';
import { externalPaths } from '../../../core/constants';
import { consent } from '../../auth/authService';
import { useAuth } from '../../auth/talents/AuthContext';

type Props = {
  onClose: () => void,
  onAccept: () => void,
};

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 580,
  },
  title: {
    minWidth: 310,
    position: 'absolute',
    top: theme.spacing(4),
    left: theme.spacing(4),
    color: theme.palette.grey.dark,
  },
  container: {
    textAlign: 'center',
  },
  containerTitle: {
    margin: 0,
    fontSize: theme.typography.pxToRem(28),
    fontWeight: theme.typography.fontWeightMedium,
  },
  iconContainer: {
    userSelect: 'none',
    position: 'relative',
    textAlign: 'center',
    height: 'fit-content',
    margin: theme.spacing(4, 0),
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    fontSize: 42,
    transform: 'translate(-50%, -50%)',
    color: theme.palette.primary.main,
  },
  introText: {
    margin: theme.spacing(3, 0),
  },
  tcppLink: {
    display: 'inline-block',
    textDecoration: 'underline',
    marginBottom: theme.spacing(3),
  },
}));

function Consent({ onClose, onAccept }: Props) {
  const { loadUser } = useAuth();
  const classes = useStyles();
  const titleId = 'success';
  const contentId = 'successContent';

  function consentAndRefetchMe() {
    consent().then(loadUser);
  }

  return (
    <Modal
      open
      onClose={onClose}
      titleId={titleId}
      contentId={contentId}
      paperClassName={classes.root}
    >
      <div className={classes.title}>Terms and conditions</div>
      <div className={classes.container}>
        <div className={classes.iconContainer}>
          <img src={splashBg} alt="icon-background" draggable="false" />
          <FontAwesomeIcon
            icon={['fal', 'shield-check']}
            className={classes.icon}
          />
        </div>
        <h2 className={classes.containerTitle}>But before that...</h2>
        <div className={classes.introText}>
          In order to proceed, we need your agreement to our terms and
          conditions. Take a moment to read them and come back to this page.
        </div>
        <div>
          <a
            href={externalPaths.privacyPolicy}
            className={classes.tcppLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Read our Terms & Conditions and Privacy Policy
          </a>
        </div>
        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={pipe(consentAndRefetchMe, onAccept)}
        >
          Accept Terms and Conditions
        </Button>
      </div>
    </Modal>
  );
}

export { Consent };
